import { motion, useReducedMotion } from "framer-motion";
import Reveal from "./Reveal";

export default function ChapterHeading({ num, eyebrow, title, copy, dark = false, testid }) {
  const reduce = useReducedMotion();
  const words = title.split(" ");
  return (
    <div data-testid={testid} className="max-w-3xl">
      <Reveal>
        <div className="flex items-center gap-4">
          <span className={`font-display text-sm font-bold tracking-[0.2em] ${dark ? "text-sage-tint" : "text-sage-dark"}`}>
            {num}
          </span>
          <span className={`h-px w-10 ${dark ? "bg-sage-tint/60" : "bg-sage"}`} aria-hidden="true" />
          <span className={`text-xs font-bold uppercase tracking-[0.2em] ${dark ? "text-sage-tint" : "text-sage-dark"}`}>
            {eyebrow}
          </span>
        </div>
      </Reveal>
      <h2
        className={`mt-5 font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl ${
          dark ? "text-ivory" : "text-charcoal"
        }`}
      >
        {words.map((word, i) => (
          <span key={i} className="inline-block overflow-hidden pb-1 align-bottom">
            <motion.span
              className="inline-block"
              initial={reduce ? { opacity: 0 } : { y: "110%" }}
              whileInView={reduce ? { opacity: 1 } : { y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: 0.1 + i * 0.05, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            >
              {word}
              {i < words.length - 1 ? "\u00A0" : ""}
            </motion.span>
          </span>
        ))}
      </h2>
      {copy && (
        <Reveal delay={0.25}>
          <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-ivory/75" : "text-ink/75"}`}>
            {copy}
          </p>
        </Reveal>
      )}
    </div>
  );
}
